<template>
  <div class="slide_wrapper zoom" v-parallax-fit="slide_wrapper">
    <div class="slide" v-parallax-fit="parallax"></div>
  </div>
</template>

<script>
export default {
  name: 'slide16',
  data() {
    return {
      parallax: [
        {
          start: 16200,
          end: 16700,
          fromStyle: { transform: 'translateY(-1360px) rotate(-10deg)' },
          toStyle: { transform: 'translateY(0px) rotate(-5deg)' },
          easing: 'linear'
        },
      ],
      slide_wrapper: [
        {
          start: 19000,
          end: 21000,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotateZ(-5deg)' },
          toStyle: { transform: 'translateY(1600px) translateX(500px) rotateZ(45deg)' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide_wrapper {
  position: fixed;
  width:100%;
  height: 100%;
  z-index: 4;
  transition: 0.6s;
  pointer-events: none;
}
.slide {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/16_NeighborhoodMap.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 840px;
    height: 675px;
    left: calc(50% - 333px);
    top: calc(50% - 364px);
    transition: 0.6s;
    z-index: 4;
    transform: rotate(0deg);
    @media(max-width: 600px) {
      width: 100vw;
      left: 0;
      top: calc(50% - 304px);
    }
}
</style>
